module.exports = __webpack_public_path__ + "img/JCB.cbd8a6cb.svg";